import { h } from 'preact';
import { useEffect, useRef, useMemo } from 'preact/hooks';

const CartBlock = ({ type, settings, total }) => {
  if (type === 'rewards') {
    useEffect(() => {
      if (window.spapi) {
        window.spapi.setupDisplayPoints();
      }
    }, [total]);

    const rewards = useMemo(
      () =>
        settings.text.replace(
          '[points]',
          `<span
            data-mode="display-points"
            class="swell-product-helper"
            data-price-cents="${total}"
          ></span>`,
        ),
      [total],
    );
    return (
      <div
        className="body-6 text-center [&_*]:body-6 [&_a]:underline [&_strong]:font-semibold [&_strong_*]:font-medium [&_a]:hover:no-underline"
        dangerouslySetInnerHTML={{
          __html: rewards,
        }}
      ></div>
    );
  }

  if (type === 'sezzle') {
    const sezzle = useRef(null);

    useEffect(() => {
      if (sezzle.current) {
        sezzle.current.alterPrice(`${parseFloat(total / 100)}`);
      }
    }, [total]);

    useEffect(() => {
      sezzle.current = new window.AwesomeSezzle({
        amount: `${parseFloat(total / 100)}`,
        renderElement: 'sezzle-cart',
        alignment: 'center',
        language: window.Shopify.locale,
        widgetTemplate: settings.text,
      });
      sezzle.current.init();
    }, []);

    return (
      <div className="sezzle-cart flex justify-center" id="sezzle-cart"></div>
    );
  }

  return null;
};

export default CartBlock;
